export default __webpack_public_path__ + "/images/gdg_logo1.png";